import {observer} from 'mobx-react';

export default observer((props) => {
  const element = document.querySelector('[data-firebase-module="menu"]')
  const language = element ? element.getAttribute('language') : null;

  let menu_source = language === 'en' ? props.data.menu_en : language === 'zh-hans' ? props.data.menu_zh_hans : props.data.menu_de

  // Subsites can have their menu. If they don't, fallback to one of the above.
  if (window.location.href.includes('schalke04.de/tv/')) {
    menu_source = props.data.menu_tv
  } else if (window.location.href.includes('schalke04.de/basketball/')) {
    menu_source = props.data.menu_basketball
  } else if (window.location.href.includes('schalke04.de/tischtennis/')) {
    menu_source = props.data.menu_tischtennis
  } else if (window.location.href.includes('schalke04.de/handball/')) {
    menu_source = props.data.menu_handball
  } else if (window.location.href.includes('schalke04.de/esports/')) {
    menu_source = props.data.menu_esports
  } else if (window.location.href.includes('schalke04.de/knappenschmiede/')) {
    menu_source = props.data.menu_knappenschmiede
  } else if (window.location.href.includes('schalke04.de/leichtathletik/')) {
    menu_source = props.data.menu_leichtathletik
  } else if (window.location.href.includes('schalke04.de/knappenkids/')) {
    menu_source = props.data.menu_knappenkids
  } else if (window.location.href.includes('schalke04.de/bolzplaetze/')) {
    menu_source = props.data.menu_bolzplaetze
  } else if (window.location.href.includes('schalke04.de/frauenfussball/')) {
    menu_source = props.data.menu_frauenfussball
  } else if (window.location.href.includes('schalke04.de/sportabteilungen/')) {
    menu_source = props.data.menu_sportabteilungen
  }

  let menu = ''

  // Build the menu
  menu_source.forEach((item) => {

    let children = ``

    if (item.children) {

      item.children.forEach((child) => {

        let grandchildren = ``

        if (child.children) {

          child.children.forEach((grandchild) => {

            grandchildren += `
              <li data-members-only="${grandchild.is_members_only && grandchild.is_members_only === 'true' ? 'true' : 'false'}" class="header-nav-item nav-item-newscenter menu-item menu-item-type-post_type menu-item-object-page menu-item-22136 item-first leaf ${grandchild.classes ? `${grandchild.classes}` : ''}">
                <a class="header-nav-link" data-members-only="${grandchild.is_members_only && grandchild.is_members_only === 'true' ? 'true' : 'false'}" href="${grandchild.link}">${grandchild.label}</a>
              </li>
            `
          })
        }

        children += `
          <li data-members-only="${child.is_members_only && child.is_members_only === 'true' ? 'true' : 'false'}" class="header-nav-item nav-item-newscenter menu-item menu-item-type-post_type menu-item-object-page menu-item-151 menu-item-has-children item-first has-submenu ${child.classes ? `${child.classes}` : ''}">
            <a href="${child.link}" data-members-only="${child.is_members_only && child.is_members_only === 'true' ? 'true' : 'false'}" class="${grandchildren ? 'header-nav-trigger' : ''}" role="button" aria-haspopup="true" aria-expanded="false">${child.label}</a>
            <div class="header-nav-menu-container level-3">
              <ul class="header-nav-submenu level-3" data-back="Zurück" data-root="${child.label}">
                <li data-submenu-title class="root">
                  <button class="back">Zurück</button>
                  <span>${item.label}</span>
                </li>
                ${grandchildren}
              </ul>
            </div>
          </li>
        `
      })
    }

    menu += `
      <li data-members-only="${item.is_members_only && item.is_members_only === 'true' ? 'true' : 'false'}" class="header-nav-item nav-item-aktuelles menu-item menu-item-type-post_type menu-item-object-page menu-item-144 menu-item-has-children item-first has-submenu ${item.classes ? `${item.classes}` : ''}">
        <a href="${item.link}" data-members-only="${item.is_members_only && item.is_members_only === 'true' ? 'true' : 'false'}" class="${children ? 'header-nav-trigger' : ''}" role="button" aria-haspopup="true" aria-expanded="false">${item.label}</a>
        <div class="header-nav-menu-container level-2">
          <ul class="header-nav-submenu level-2" data-back="Zurück" data-root="${item.label}">
            <li data-submenu-title class="root">
              <button class="back">Zurück</button>
              <span>${item.label}</span>
            </li>
            ${children}
          </ul>
        </div>
      </li>`
  })

  element.innerHTML = `
    <nav class="nav-main" data-module='[ [ "modules/nav-main--mobile", "media:{(max-width:1199px)}" ], [ "modules/nav-main--desktop", "media:{(min-width:1200px)}" ] ]'>
      <div class="header-nav-menu-container level-1">
        <ul class="header-nav-menu level-1">
          ${ menu }
        </ul>
      </div>
    </nav>
  `

  const isMobileLayout = () => {
    const burger = document.querySelector('.header-mobile-navigation-indicator')
    if (burger) {
      const burgerStyles = window.getComputedStyle(burger);
      return burgerStyles.getPropertyValue('display') !== 'none';
    }
  }

  // Desktop layout
  // BOF: legacy JS
  if (typeof $ !== 'undefined') {
    // eslint-disable-next-line
    $('.nav-main').on('click', '.header-nav-trigger', function(event) {
      if (window.innerWidth <= 1199) {
        event.preventDefault();

        // eslint-disable-next-line
        var trigger = $(event.currentTarget);

        // trigger.find('.header-nav-submenu');
        trigger.closest('li').addClass('open');
        trigger.closest('.header-nav-menu-container').addClass('submenu-activated');
      }
    });

    // eslint-disable-next-line
    $('.nav-main').on('click', '.back', function(event) {
      event.preventDefault();

      // eslint-disable-next-line
      var back = $(event.currentTarget);

      back.closest('.header-nav-menu-container').parent().removeClass('open').closest('.header-nav-menu-container').removeClass('submenu-activated');
    });

    var closeDesktopSubmenus = function () {
      // eslint-disable-next-line
      $('.header-nav-menu.level-1 > li.hover').addClass('hiding').removeClass('hover');
    }

    // eslint-disable-next-line
    $('.nav-main').on('click', '.header-nav-menu.level-1 > li > .header-nav-trigger', function (evt) {
      if (window.innerWidth >= 1200) {
        evt.preventDefault();

        // eslint-disable-next-line
        var trigger = $(event.target);
        var triggerWrapper = trigger.parents('li');

        if (triggerWrapper.hasClass('hover')) {
          triggerWrapper.addClass('hiding').removeClass('hover');
        } else {
          // Close all opened submenus
          closeDesktopSubmenus();

          triggerWrapper.addClass('hover').removeClass('hiding');
        }
      }
    });

    // eslint-disable-next-line
    $('.nav-main').on('transitionend', '.header-nav-menu-container.level-2', function (evt) {
      // eslint-disable-next-line
      var trigger = $(event.target);
      var triggerWrapper = trigger.parents('li');

      if (triggerWrapper.hasClass('hiding') && !triggerWrapper.hasClass('hover')) {
        triggerWrapper.removeClass('hiding')
      }
    });

    // Close submenus on press escape
    // eslint-disable-next-line
    $(window).on('keydown', function (evt) {
      if (window.innerWidth >= 1200) {
        if (evt.key === "Escape") {
          closeDesktopSubmenus();
        }
      }
    });

    // Close submenu on click outside
    // eslint-disable-next-line
    $(document.body).on('click', function (evt) {
      if (window.innerWidth >= 1200) {
        // eslint-disable-next-line
        var trigger = $(evt.target);
        if (!trigger.hasClass('nav-main') && !trigger.parents('.nav-main').length) {
          closeDesktopSubmenus();
        }
      }
    });
  }
  // EOF: legacy JS

  if (typeof window.parseToken !== 'undefined') {
    window.parseToken()
  }
})